/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultTemplateChat } from '../../models/api-response-paged-result-template-chat';
import { PagedRequestString } from '../../models/paged-request-string';

export interface SearchListTemplate$Params {
  wabaId?: string;
  senderReference?: string;
  'x-api-requestId': string;
  'x-api-canal': string;
  folderId?: number;
      body: PagedRequestString
}

export function searchListTemplate(http: HttpClient, rootUrl: string, params: SearchListTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateChat>> {
  const rb = new RequestBuilder(rootUrl, searchListTemplate.PATH, 'post');
  if (params) {
    rb.query('wabaId', params.wabaId, {});
    rb.query('senderReference', params.senderReference, {});
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultTemplateChat>;
    })
  );
}

searchListTemplate.PATH = '/v1/api/ui/templates-chat/search-list';
